import { ReactElement, useEffect, useRef } from 'react';
import { StyledChartTooltip, TooltipStyled } from '../../ChartTooltip/ChartTooltip.styles';
import { TitleStyled, ValueStyled } from '../../ChartTooltipContent/ChartTooltipContent.styles';
import { styled } from '@/stitches.config';
import { ReactComponent as Poligon } from '@assets/icons/tooltip-poligon.svg';

const TooltipPolygon = styled(Poligon, {
  transform: 'translate(-10px, -40px) rotateZ(90deg)',
});

interface MultipleValueTooltipProps {
  data: any;
  onChangeTooltipWidth: Function;
  tooltip?: string;
  isTooltipActive: boolean;
  tooltipEndValue?: string;
  backgroundColor?: string;
}

export const MultipleValueTooltip = ({
  data,
  onChangeTooltipWidth,
  tooltip,
  isTooltipActive,
  tooltipEndValue,
  backgroundColor = '$white',
}: MultipleValueTooltipProps): ReactElement | null => {
  const customTooltipRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (customTooltipRef.current) {
      onChangeTooltipWidth(customTooltipRef.current.getBoundingClientRect()?.width);
    }
  }, [customTooltipRef.current]);

  const tooltipData = data?.tooltipPayload && data.tooltipPayload.length > 0 ? data.tooltipPayload[0] : null;

  if (tooltip && isTooltipActive) {
    return (
      <StyledChartTooltip ref={customTooltipRef}>
        <TooltipStyled css={{ backgroundColor }}>
          <TitleStyled>{`${tooltip}`}</TitleStyled>
          <ValueStyled css={{ marginLeft: '$1' }}>{`${String(tooltipData?.value)} ${
            tooltipEndValue ?? ''
          }`}</ValueStyled>
        </TooltipStyled>
        <TooltipPolygon />
      </StyledChartTooltip>
    );
  }
  return null;
};
